<template>
  <!-- 默认佣金设置 -->
  <div>
    <!-- 基础设定模块 -->
    <el-card>
      <div slot="header">
        <div class="title">
          基础设定
        </div>
        <div class="subtitle">
          <span
            class="tips"
          >当前佣金设置为全局设置，若商品规格设置了佣金，则实际佣金计算依据商品维度计算</span>
          <el-button
            type="text"
            @click="toGoodsCommission"
          >
            设置单品佣金
          </el-button>
        </div>
      </div>
      <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="150px"
        label-position="left"
      >
        <el-form-item label="默认销售佣金比例：">
          <el-input
            v-model="dataForm.sales"
            placeholder="请输入内容"
            @input="handleInput"
          >
            <template slot="append">
              %
            </template>
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="默认线下佣金比例：">
          <el-input
            v-model="dataForm.offline"
            placeholder="请输入内容"
          >
            <template slot="append">
              %
            </template>
          </el-input>
        </el-form-item> -->
        <el-form-item label="默认绑定佣金比例：">
          <el-input
            v-model="dataForm.bind"
            placeholder="请输入内容"
            @input="handleInputBind"
          >
            <template slot="append">
              %
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <div class="fotter-toolbar">
      <el-button
        type="primary"
        :loading="submitLoading"
        @click="onSubmit"
      >
        保存设置
      </el-button>
    </div>
  </div>
</template>

<script>
import { getSetting, setSetting } from '@/api/staffManagement/relationBind'
export default {
  data () {
    return {
      submitLoading: false,
      dataForm: {
        sales: '',
        offline: '',
        bind: ''
      }
    }
  },
  mounted () {
    this.getSetting()
  },
  methods: {
    // 保留两位小数
    matchNumber (value) {
      return value.match(/^\d*(\.?\d{0,2})/g)[0] || null
    },

    handleInput (value) {
      this.dataForm.sales = this.matchNumber(value)
    },
    handleInputBind (value) {
      this.dataForm.bind = this.matchNumber(value)
    },
    // 获取导购配置
    async getSetting () {
      const data = await getSetting()
      if (data) {
        this.dataForm = data
      }
    },
    // 设置导购配置
    async setSettingFun (params) {
      const data = await setSetting(params).catch(() => {
        this.submitLoading = false
      })
      if (data) {
        this.submitLoading = false
        this.$message({ type: 'success', message: '保存成功' })
      }
    },
    // 保存
    onSubmit () {
      this.submitLoading = true
      this.setSettingFun(this.dataForm)
    },
    // 设置单品佣金
    toGoodsCommission () {
      this.$router.push({ path: '/relationship/goodsCommission' })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  width: 700px;
}
.form-tips {
  display: flex;
  align-items: center;
  margin: -5px 0;
}
.form-title {
  font-size: 18px;
  color: #606266;
}
.checklist {
  display: block;
  margin-bottom: 20px;
}
.bind_bottom {
  width: 100%;
  display: flex;
  justify-content: center;
  .submit-btn {
    width: 300px;
  }
}
.tips-box {
  background-color: rgba(239, 239, 239, 1);
  padding: 10px 20px;
  font-size: 13px;
  color: #666666;
  line-height: 24px;
  .tips-title {
    color: #999999;
    margin-bottom: 10px;
  }
  .tips-list {
    display: flex;
    .tips-list-title {
      width: 180px;
    }
    .tips-list-content {
      flex: 1;
    }
    span {
      color: #69aa00;
    }
  }
}
.el-input-group--append {
  width: 160px;
  margin-right: 10px;
}
.setting-top {
  margin-bottom: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
